import { render, staticRenderFns } from "./DocuPersonalTasks.vue?vue&type=template&id=081205ba&scoped=true&"
import script from "./DocuPersonalTasks.vue?vue&type=script&lang=js&"
export * from "./DocuPersonalTasks.vue?vue&type=script&lang=js&"
import style0 from "./DocuPersonalTasks.vue?vue&type=style&index=0&id=081205ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081205ba",
  null
  
)

export default component.exports